import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { LicenseApplyEventAdapter } from '~analytics/index';

import view from 'ActivateLicenseView';
import dots from 'Dots';
import LicenseModel from 'LicenseModel';
import utils from 'Utils';

let model = null;

class ActivateLicenseController {
  render(props) {
    model = new LicenseModel();
    model.activateCallback = props.activateCallback;

    let container = document.createElement('div');
    container.id = 'activate-license-modal-container';
    document.body.appendChild(container);

    controller.renderView();
  }

  renderView() {
    ReactDOM.render(
      React.createElement(view, {
        controller: controller,
        model: model,
      }),
      document.getElementById('activate-license-modal-container'),
      () => {
        if (!model.pageBlurred) {
          model.pageBlurred = true;
          utils.blurPage();
        }
      }
    );
  }

  licenseKeyChanged(value) {
    model.key = value.trim();
    model.setError('licenseKey', false);
    controller.renderView();
  }

  activateClicked() {
    dots.start('activate-license-button-id');
    controller.renderView();
    model.activateLicense(controller.activateLicenseResult);
  }

  activateLicenseResult(success, licenseExpiration) {
    if (success) {
      new LicenseApplyEventAdapter(false).sendAnalytics();
      controller.cancelClicked();

      model.activateCallback(licenseExpiration, model.key);
      window.SOCRATIVE.teacherRouter.routeToProfileBilling();
      window.location.reload();
    } else {
      dots.stop();
      controller.renderView();
    }
  }

  cancelClicked() {
    let container = document.getElementById('activate-license-modal-container');
    ReactDOM.unmountComponentAtNode(container);
    container.parentNode.removeChild(container);
    utils.unblurPage();
    window.SOCRATIVE.teacherRouter.routeToProfileBilling();
  }
}

const controller = new ActivateLicenseController();
module.exports = controller;
